import { createSlice } from "@reduxjs/toolkit";

// 0 = qCardCompletedCourses
// 1 = qCardTrainingHours
// 2 = qCardCertificates
// 3 = CardRunningCourses
// 4 = CardRunningActions
// 5 = DonutChart
// 6 = CardNotifications
// 7 = TableInscription
// 8 = TableRequests
// 9 = TableRealized
// 10 = CoursesCatalog
// token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1bmlxdWVfbmFtZSI6IjMwZWFjOGU2LTQ1N2UtNDdlYi04ZTU2LTAyNTI4NmQxOTkxYiIsIkNhbk5hbWUiOiJUcnVlIiwibmJmIjoxNjI4MDgzMjEwLCJleHAiOjE2Mjg1MTUyMTAsImlhdCI6MTYyODA4MzIxMH0.XD0fvh_3B-JjDgtlo6saRbthHvKQTPHLjjZgh87JWvE"
const initialState = {
	isLoading: [
		true,
		true,
		true,
		true,
		true,
		true,
		true,
		true,
		true,
		true,
		true,
	],
	autentication: {
		cookie: "SIGPAPE",
		cookieToken: "",
		token: "",
		refreshToken: "",
	},
	user: {
		id: "",
		name: "",
		picture: ""
	},
	redirect: {
		login: "/",
	},
};

const uiSlice = createSlice({
	name: "ui",
	initialState: initialState,
	reducers: {
		showLoadingSpinner(state, action) {
			// console.log("showLoadingSpinner", action.payload);
			state.isLoading[action.payload] = true;
		},
		hideLoadingSpinner(state, action) {
			// console.log("hideLoadingSpinner", action.payload);
			state.isLoading[action.payload] = false;
		},
		updateCookieToken(state, action) {
			// console.log("updateCookieToken", action.payload);
			state.autentication.cookieToken = action.payload;
		},
		updateToken(state, action) {
			// console.log("updateToken", action.payload);
			state.autentication.token = action.payload.jwtToken;
			state.autentication.refreshToken = action.payload.refreshToken;
		},
		updateUserData(state, action) {
			// console.log("updateUserData", action.payload);
			state.user.name = action.payload.profileName;
		},
		updateUserPicture(state, action) {
			console.log("updateUserPicture", action.payload);
			state.user.picture = action.payload;
		},
	},
});

export const uiActions = uiSlice.actions;

export default uiSlice;
